// Production
export const DEAL_STAGES = {
	INTAKE: '239805239',
	PROPOSAL_CREATION_ASSIGNED: 'appointmentscheduled',
	PROPOSAL_CREATION_READY_FOR_APPROVAL: '218672959',
	PROPOSAL_CREATION_APPROVED_READY_TO_SEND: 'qualifiedtobuy',
	PROPOSAL_APPROVED_SENT_TO_CUSTOMER: '218672960',
	PENDING_NEED_MORE_INFOMATION: '943259251',
	FINALIZED_PRICING_SENT_TO_CUSTOMER: '218672962',
	SENT_EMAIL_FOR_DEALER_INTRO: '218672961',
	SENT_TO_DEALER: '218672963',
	DEALER_ONSITE_COMPLETED: 'presentationscheduled',
	INSTALLATION_SCHEDULED: 'closedlost',
	INSTALLATION_COMPLETED: '218672964',
	OUT_OF_SERVICE: '990401074',
	TEST_COLUMN_FOR_DEVS: '991800661',
	INACTIVE_DEAL: '249844830',
} as const;
